import { Component, OnInit } from '@angular/core';
import { HttpInterceptorHandler } from '@angular/common/http/src/interceptor';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '../shared/services/authentication.service';
import { Router } from '@angular/router';
import { ShowHideContainer } from './show-hide-container';
import { TypeService } from '@shared/services/type.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public displayMenu: boolean = false; // for hide sidebar ana header
  rForm: FormGroup;
  post: any;                     // A property for our submitted form

  titleAlert: string = 'This field is required';
  token: any;
  errorMessage: string;
  isLoggedIn: any;
  isLoading: boolean = false;
  username: string;
  error = '';
  loading: boolean;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthenticationService,
    private typeService: TypeService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {

    this.rForm = formBuilder.group({
      'username': [null, Validators.required],
      'password': [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(15)])],
      'remember': ''  // this was from the example and needs to be renamed. Here and on the html page
    });

  }

  ngOnInit() {
    //  this.authenticationService.logout(); don't log them out just because they came here.
    //  but if they are logged in then send them back to the main page, there is a logout feature there.
    sessionStorage.clear();
    localStorage.clear();
    if (!JSON.parse(localStorage.getItem('currentUser')) || !JSON.parse(sessionStorage.getItem('currentUser'))) {
      this.authService.logout();
    }

  }

  addPost(post) {
    let self = this;
    this.spinnerService.show();
    this.error = '';
    this.isLoading = true; // not sure what this was for.
    this.isLoggedIn = this.authService.login(post.username, post.password, post.remember)
      .subscribe(result => {
        this.token = result;
        if (this.token) {
          this.error = '';
          this.displayMenu = true;
          this.typeService.getAllTypes();
          self.redirect();
        } else {
          this.spinnerService.hide();
          this.error = 'Username or password is incorrect';
          this.isLoading = false;

        }
      },
      error => {
        this.spinnerService.hide();
        this.errorMessage = <any>error;
        this.error = 'Username or password is incorrect';

      },
      () => this.spinnerService.hide() );
}

  redirect() { // TODO: convert to using a route guard in Sprint 2
   
    const link = ['dashboard'];
    // const link = ['organizations'];
    this.router.navigate(link);
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts